import React, { useEffect } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { TextInput, SelectInput } from '../../../../Helpers/Inputs';
import { setBasicInfo } from '../../../../../sessionStorage';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { object, string } from 'yup';
import '../Appointment.scss';
import States from '../../../../Helpers/Lists/States';
import PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import CheckIcon from '@material-ui/icons/Check';
import SvgIcon from "@material-ui/core/SvgIcon";

export default function Information(props) {


    const { register, errors, handleSubmit, setValue } = useForm({
        validationSchema: Information.ValidationSchema,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    // manually call setValue for fields that don't play nice with react-hook-form register
    const handleValueChange = (field, value) => {
        setValue(field, value);
        props.onFieldChange(field, value);
    };

    useEffect(() => {
        let email=props.formState.email, firstName=props.formState.firstName , lastName = props.formState.lastName;
        if (props.basicInfo && props.basicInfo.firstName !== '') {
            firstName = props.basicInfo.firstName;
        }
        if (props.basicInfo && props.basicInfo.lastName !== '') {
            lastName = props.basicInfo.lastName;
        }
        if (props.basicInfo && props.basicInfo.email !== '') {
             email = props.basicInfo.email;
        }
        props.setMultiField(firstName,lastName,email);
    }, [])


    useEffect(() => {
        // Save data into basic info when updated

        if (props.basicInfo.firstName !== props.formState.firstName) {
            props.basicInfo.firstName = props.formState.firstName;
        }

        if (props.basicInfo.lastName !== props.formState.lastName) {
            props.basicInfo.lastName = props.formState.lastName;
        }

        if (props.basicInfo.email !== props.formState.email) {
            props.basicInfo.email = props.formState.email;
        }

        setBasicInfo(props.basicInfo);

    }, [props.formState.firstName, props.formState.lastName, props.formState.email]);
    useEffect(() => {
        // manually register fields for validation that don't play nice with react-hook-form register
        register({ name: 'firstName' });
        setValue('firstName', props.formState.firstName);

        register({ name: 'lastName' });
        setValue('lastName', props.formState.lastName);

        register({ name: 'email' });
        setValue('email', props.formState.email);

    }, [register]);

    return (
        <Col xs={12} md={6} lg={4}>
            <Row className="justify-content-center text-center mt-2 hide-class">
                <SvgIcon component={CheckIcon} className="icons" color="primary" fontSize="large" />
            </Row>
            <Row className="justify-content-center pt-2 pb-1">
                <h4>Let's start the application</h4>
            </Row>
            <Row className="mt-0 justify-content-center">           
                 <h6 className='hide-class'>We need some basic information.</h6>
                 <h6 className='display-class'>First things first.</h6>
            </Row>
            <Form onSubmit={handleSubmit(props.onNext)} className='mt-3'>
                <Form.Group>
                    <TextInput
                        name="firstName"
                        id="firstName"
                        label="First Name"
                        value={props.formState.firstName}
                        errors={errors && errors.firstName}
                        inputRef={register}
                        onChange={(e) => handleValueChange('firstName', e.target.value)}
                    />
                </Form.Group>

                <Form.Group>
                    <TextInput
                        name="lastName"
                        id="lastName"
                        label="Last Name"
                        value={props.formState.lastName}
                        errors={errors && errors.lastName}
                        inputRef={register}
                        onChange={(e) => handleValueChange('lastName', e.target.value)}
                    />
                </Form.Group>

                {props.showStateDropdown &&
                    <Form.Group>
                        <SelectInput
                            name="state"
                            id="state"
                            value={props.formState.state}
                            onChange={(e) => handleValueChange('state', e.target.value)}
                            label="State"
                            selectOptions={States()}
                            errors={errors && errors.state}
                        />
                    </Form.Group>
                }

                <Form.Group>
                    <TextInput
                        name="email"
                        id="email"
                        label="Email"
                        value={props.formState.email}
                        errors={errors && errors.email}
                        inputRef={register}
                        onChange={(e) => handleValueChange('email', e.target.value)}
                    />
                </Form.Group>
                <Row className="mt-4">
                    <Col className="text-left pb-3 btn-back">
                        <Button variant="outlined" className='w-100' size="medium" color="primary" onClick={props.onBack}>
                            BACK
                        </Button>
                    </Col>
                    <Col className="text-right pb-3">
                        <Button variant="contained" className='w-100' size="medium" color="primary" type="submit">
                            NEXT
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Col>
    )
}

Information.ValidationSchema = object().shape({
    firstName: string().required('First Name is required.').matches(/^[a-zA-Z]+$/, 'Invalid First Name'),
    lastName: string().required('Last Name is required.').matches(/^[a-zA-Z]+$/, 'Invalid Last Name'),
    email: string()
        .email('Email Address must be valid.')
        .required('Email Address is required.'),
});

Information.DefaultFormState = (prefill = false, basicInfo = null) => {
    return null
};

Information.propTypes = {
    formState: PropTypes.object.isRequired,
    quoter: PropTypes.object.isRequired,
    basicInfo: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    isAppointmentSchedulingEnabled: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Appointment/AppointmentSteps/Information.js